import api from "./api";

class ContattiManager {
    myContatti(config?: any) {
        return api.get(`me/contatti`, config);
    }

    contatti(config?: any) {
        return api.get(`/contatti`, config);
    }

    search(config?: any) {
        return api.get(`/contatti/search`, config);
    }

    contatto(id: number | string) {
        return api.get(`/contatti/${id}/`);
    }

    contattiAc(config?: any) {
        return api.get(`/contattiAc`, config);
    }

    contattoAc(id: number | string) {
        return api.get(`/contattiAc/${id}/`);
    }

    contattiCreate(cliente_id: string | number, data: any) {
        return api.post(`clienti/${cliente_id}/contatti`, data);
    }

    contattiUpdate(contatto_id: string | number, data: any) {
        return api.put(`contatti/${contatto_id}`, data);
    }

    contattoHobbies(contatto_id: string | number) {
        return api.get(`contatti/${contatto_id}/hobbies`);
    }

    accounts(contatto_id: string | number) {
        return api.get(`contatti/${contatto_id}/accounts`);
    }

    export(config?: any) {
        return api.get(`/contatti/export`, config);
    }

    retrieveAll(ids: number[]) {
        return api.get(`/contatti/ids`, {params: {ids}}) 
    }

    retrieve = this.contattoAc;
    list = this.contattiAc;
    paginatedList = this.contatti;
}

const contattiManager = new ContattiManager();

export default contattiManager;
